import type { ConsentStatus } from "@/api/consent-types";

/** Marketing channels the single opt-in toggle controls. Email is included
 * only when an email is on file. Never touches sms or analytics. */
export function marketingChannelStatuses(
  optIn: boolean,
  hasEmail: boolean,
): Partial<Record<"whatsapp" | "push" | "email", ConsentStatus>> {
  const status: ConsentStatus = optIn ? "opted_in" : "opted_out";
  const out: Partial<Record<"whatsapp" | "push" | "email", ConsentStatus>> = {
    whatsapp: status,
    push: status,
  };
  if (hasEmail) out.email = status;
  return out;
}

/** True iff the customer is opted in to at least one marketing channel. */
export function isMarketingOptedIn(consent: {
  whatsapp: { status: string };
  push: { status: string };
  email: { status: string };
}): boolean {
  return (
    consent.whatsapp.status === "opted_in" ||
    consent.push.status === "opted_in" ||
    consent.email.status === "opted_in"
  );
}
